module.exports = __webpack_public_path__ + "img/electronic_use_selected.0efc2906.svg";